import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ custom }) => ({
  headerSubTitle: {
    color: '#646464',
    letterSpacing: '0.17px',
    lineHeight: '143%',
  },
  headerTitle: {
    color: '#00000099',
    fontWeight: '500',
    fontSize: '16px',
    letterSpacing: '0.17px',
    lineHeight: '143%',
  },
  headerTitle1: {
    color: '#00000099',
    fontWeight: '400',
    fontSize: '16px',
    letterSpacing: '0.17px',
    lineHeight: '143%',
  },
  mainCardIntegrations: {
    height: '100%',
    '& .MuiCardContent-root': {
      padding: 0,
      paddingBottom: 0,
    },
  },
  cardContentIntegrationCard: {
    height: '100%',
    position: 'relative',
    maxHeight: 254,
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'column',
  },
  cardImageHeader: {
    marginBottom: 10,
    '& svg': {
      width: 50,
      height: 50,
    },
  },
  integrationDescription: {},
  cardHeader: {
    marginBottom: 8,
    '& .title': {
      fontWeight: 400,
    },
    '& .value': {
      fontSize: 13,
      fontWeight: 300,
      color: '#9d7596',
    },
  },
  gridContent: {
    marginBottom: 30,
  },
  gridContentRowDataDeActive: {
    display: 'flex',
    alignItems: 'center',
    color: '#ebebeb',
  },
  gridContentRowDataActive: {
    display: 'flex',
    alignItems: 'center',
    color: '#4CAF50',
  },
  cardFooter: {
    bottom: 24,
    // position: 'absolute',
    width: 'calc(100% - 34px)',
  },
  gridFooterRowData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .installation': {},
    '& .connect': {
      '& .manage-link': {
        color: '#5780ab',
        textDecoration: 'none',
        backgroundColor: 'transparent',
      },
    },
  },
  connected: {
    color: '#EF5350',
    '& svg': {
      fontSize: '2rem',
    },
  },
  disConnected: {
    color: '#ebebeb',
    '& svg': {
      fontSize: '2rem',
    },
  },
  switch: {
    display: 'flex',
    justifyContent: 'end',
  },
  emailVerification: {
    color: 'rgba(0, 0, 0, 0.87))',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.14px',
  },
  emailVerificationSubText: {
    color: 'rgba(0, 0, 0, 0.60)',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20.02px',
    letterSpacing: '0.17px',
  },
  emailVerificationCard: {
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0px 0px 0px 1px #E0E0E0',
    margin: 0,
  },
  emailVerificationSubCard: {
    margin: 0,
    // padding: '16px',
    borderRadius: '10px',
    // border: '1px solid #DFDFDF',
    boxShadow: 'none',
  },
  emailVerificationSwitchLabel: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '18.672px',
    marginRight: '10px',
  },
}));
